module.exports = __webpack_public_path__ + "static/media/photo117.b4c27d55.jpg";